// Pickup terms shown across the cart, checkout and confirmation pages.
//
// These are duplicated in lambda/order-handler/index.js for the order emails —
// change them in both places, or the site and the emails will disagree about
// where and when a customer should collect.

/** Both places a customer can go, as shown on the home page. */
export const LOCATIONS = [
  {
    city: 'Dover',
    address: '13514 Glen Harwell Rd #B2, Dover, FL 33527',
    mapsUrl: 'https://maps.google.com/?q=13514+Glen+Harwell+Rd+B2,+Dover,+FL+33527'
  },
  {
    city: 'Tampa',
    address: '20072 Heritage Point Dr, Tampa, FL 33647',
    mapsUrl: 'https://maps.google.com/?q=20072+Heritage+Point+Dr,+Tampa,+FL+33647'
  }
];

// The disabled checkout and the order emails still name one pickup point.
// Offer a choice of location there before checkout is re-enabled.
export const PICKUP_STREET = '13514 Glen Harwell Rd #B2';
export const PICKUP_CITY = 'Dover, FL 33527';
export const PICKUP_ADDRESS = `${PICKUP_STREET}, ${PICKUP_CITY}`;
export const PICKUP_MAPS_URL =
  'https://maps.google.com/?q=13514+Glen+Harwell+Rd+B2,+Dover,+FL+33527';

export const PICKUP_HOURS = '7 days a week, 10am–6pm';

/** How long a ready order is held before we chase the customer. */
export const HOLD_DAYS = 7;

/** The owner's list, as given. It deliberately says nothing about cards. */
export const PAYMENT_METHODS = 'Cash App, Zelle, check or cash';

export const BUSINESS_PHONE = '(251) 751-5962';
export const BUSINESS_PHONE_HREF = 'tel:2517515962';
export const BUSINESS_EMAIL = 'inquiries@tampabeesupply.com';
